module.exports = __webpack_public_path__ + "img/Frente-51-02 open.57d4b9aa.jpg";